// src/api/axios.js
import axios from "axios";
import router from "@/router"; // import your router instance

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 100000,
});

// Request interceptor
apiClient.interceptors.request.use((config) => {
  let token = null;

  // 1️⃣ Get token from route param if it exists
  const currentRoute = router.currentRoute.value;
  if (currentRoute?.params?.token) {
    token = currentRoute.params.token;
  }

  // 2️⃣ Fallback to localStorage token
  if (!token) {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        token = JSON.parse(storedUser)?.token;
      } catch (e) {
        console.warn("Invalid user JSON in localStorage");
      }
    }
  }

  // 3️⃣ Attach token if available
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}, (error) => Promise.reject(error));

// Response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.message || error.message || "API request failed";
    console.error("[API ERROR]", message);
    return Promise.reject(new Error(message));
  }
);

export default apiClient;
